<ng-container *ngIf="show">
	<div class="overlay">
		<div class="loader"></div>
	</div>
</ng-container>
